<template>
	<div class="menu-container">
		<div v-if="!isMobile" class="navbar-white">
			<Navbar
				class="desktop-center"
				:logoSrc="$logoSrc"
				:backButton="false"
			/>
		</div>
		<div class="navbar-page menu-page-container">
			<div
				class="menu-page sk-scrollbar vld-parent"
				ref="menuPage"
				@scroll.passive="handleMenuScroll"
			>
				<div v-if="isMobile" class="navbar-white">
					<Navbar
						class="desktop-center"
						:logoSrc="$logoSrc"
						:backButton="false"
					/>
				</div>
				<Banner />
				<div v-if="!loading" class="menu-page-content">
					<ComingSoonSection v-if="showComingSoon" />
					<OfflineWidgetAlt v-if="showOffline" />
					<div v-if="showMenu" class="vld-parent">
						<HorizontalNavbar
							ref="menuHeader"
							class="desktop-center menu-header"
							:isSticky="headerSticky"
							:stickyEnabled="headerSticky"
							:options="menuTabs"
							:stickyOffset="0"
							@optionSelected="tabClicked"
						/>
						<MenuCategoryNavbar
							v-if="!isPopup"
							ref="menuCategoryNavbar"
							:categorizedMenu="categorizedMenu"
							:stickyEnabled="headerSticky"
							@scrollToSelectedCategory="scrollToSelectedCategory"
						/>
						<LateNightBanner />
						<PopupBanner />
						<BackupBanner />
						<loading :active="loadingMenu" :is-full-page="false" />
						<CategorizedMenu
							ref="categorizedMenuRef"
							:categorizedMenu="categorizedMenu"
						/>
					</div>
				</div>
				<div v-if="showMenu">
					<Footer
						@openCartSummary="openCartSummary"
						:showDeliveryBar="true"
					/>
				</div>
			</div>
			<FloatingCartSummary ref="cartSummary" :showDeliveryBar="true" />
		</div>
		<ItemModal ref="itemModal" />
	</div>
</template>

<script>
import menuMixin from "@/mixins/menu-mixin"
import voucherMixin from "@/mixins/voucher-mixin"
import menuCategoriesMixin from "@/mixins/menu-categories-mixin"
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"
import Navbar from "@/components/navbars/Navbar.vue"
import Banner from "@/components/Banner.vue"
import MenuItem from "@/components/menu/MenuItem.vue"
import Footer from "@/components/Footer.vue"
import HorizontalNavbar from "@/components/common/HorizontalNavbar.vue"
import ComingSoonSection from "@/components/menu/ComingSoonSection.vue"
import Loading from "vue-loading-overlay"
import FloatingCartSummary from "@/components/common/FloatingCartSummary.vue"
import LateNightBanner from "@/components/menu/LateNightBanner.vue"
import PopupBanner from "@/components/menu/PopupBanner.vue"
import BackupBanner from "@/components/menu/BackupBanner.vue"
import CategorizedMenu from "@/components/menu/CategorizedMenu.vue"
import MenuCategoryNavbar from "@/components/menu/MenuCategoryNavbar.vue"
import OfflineWidgetAlt from "@/components/menu/OfflineWidgetAlt.vue"
import ItemModal from "@/components/modals/ItemModal.vue"

export default {
	name: "HotelMenu",
	mixins: [
		menuMixin,
		voucherMixin,
		menuCategoriesMixin,
		mobileResponsivenessMixin
	],
	components: {
		Banner,
		MenuItem,
		Navbar,
		Footer,
		HorizontalNavbar,
		Loading,
		ComingSoonSection,
		FloatingCartSummary,
		LateNightBanner,
		PopupBanner,
		BackupBanner,
		CategorizedMenu,
		MenuCategoryNavbar,
		OfflineWidgetAlt,
		ItemModal
	},
	data: function () {
		return {
			headerSticky: false
		}
	},
	created: function () {
		if (
			this.$route.params.table != undefined ||
			this.$store.getters.table != -1
		) {
			if (this.$route.params.table != undefined) {
				this.$store.dispatch(
					"setCurrentTable",
					this.$route.params.table
				)
			} else if (this.$route.params.table == 0) {
				this.$store.dispatch("setCurrentTable", -1)
			}
		} else {
			this.$store.dispatch("setCurrentTable", -1)
		}

		if (
			this.$route.query.code != undefined &&
			this.$route.query.code != ""
		) {
			this.validateVoucher()
		}
	},
	mounted: function () {
		this.trackOutOfStock()
		this.trackComingSoon()
		this.openPreorderOnlyModalIfNeeded()
	},
	methods: {
		openCartSummary() {
			this.$refs.cartSummary.open()
		},
		handleMenuScroll() {
			const menuHeader = this.$refs.menuHeader

			if (menuHeader && menuHeader.$el) {
				const rect = menuHeader.$el.getBoundingClientRect()
				const threshold = this.isMobile ? 0 : 75
				this.headerSticky = rect.top <= threshold + 5
			}

			if (
				this.$refs.categorizedMenuRef &&
				this.$refs.categorizedMenuRef.$refs
			) {
				this.calculateCategoryWhenScrolling(
					this.$refs.menuCategoryNavbar,
					this.$refs.categorizedMenuRef.$refs["category-section"]
				)
			}
		}
	},
	computed: {
		categorizedMenuRefKey() {
			return "categorizedMenuRef"
		}
	}
}
</script>

<style scoped>
.vld-parent >>> .vld-icon {
	position: absolute;
	top: 150px;
}

.menu-page {
	padding-left: 0;
	padding-right: 0;
}
</style>

